import Vue from 'vue'

Vue.directive('visible', function (el, binding) {
  const value = binding.value
  el.style.visibility = value ? 'visible' : 'hidden'
})
